import PaymentMethodType from 'types/enums/PaymentMethodType';
import Order from 'types/models/Order';

export const getPaymentKey = (order: Order): string => {
  if (order.isCash) {
    return PaymentMethodType.Cash;
  } else if (
    order.payment?.fiservQrPayment?.id ||
    (order.payment?.cloverPointPayment &&
      ['Mercado Pago', 'Pix'].includes(order.payment?.cloverPointPayment?.paymentMethod))
  ) {
    return PaymentMethodType.Qr;
  } else {
    return PaymentMethodType.Card;
  }
};
